exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adder-card,.adder-card .v-input--selection-controls .v-icon,.adder-card .v-input--selection-controls .v-input__control{color:#006aff}.adder-card .v-input--selection-controls.v-input .v-label{color:#000}.adder-card .v-input--selection-controls{margin-top:0}.adder-card .card-title .v-input__slot{margin-bottom:0}.adder-card.hp-adder .v-image{border-radius:0!important}", ""]);

// exports
